import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import LoginPage from './pages/LoginPage';
import SetPasswordPage from './pages/SetPasswordPage';
import JoinPage from './pages/JoinPage';
import PrivacyPage from './pages/PrivacyPage';
import DataDeletionPage from './pages/DataDeletionPage';
import TermsPage from './pages/TermsPage';
import MemberLayout from './components/MemberLayout';
import BenefitsPage from './pages/member/BenefitsPage';
import NewsPage from './pages/member/NewsPage';
import MyCardsPage from './pages/member/MyCardsPage';
import AdvertisementPage from './pages/member/AdvertisementPage';
import SettingsPage from './pages/member/SettingsPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminMembersPage from './pages/admin/AdminMembersPage';
import AdminContentPage from './pages/admin/AdminContentPage';
import AdminCommitteesPage from './pages/admin/AdminCommitteesPage';
import AdminLettersPage from './pages/admin/AdminLettersPage';
import AdminLetterSendPage from './pages/admin/AdminLetterSendPage';
import AdminSponsorsPage from './pages/admin/AdminSponsorsPage';
import AdminSponsorPage from './pages/admin/AdminSponsorPage';
import AdminSeatingPage from './pages/admin/AdminSeatingPage';
import AdminCheckInPage from './pages/admin/AdminCheckInPage';
import AdminBudgetPage from './pages/admin/AdminBudgetPage';
import AdminReportPage from './pages/admin/AdminReportPage';
import RsvpPage from './pages/RsvpPage';

/**
 * HKSCA — App（路由 ＋ 認證）
 *  · 會員區 `/member/*`：底部 5 tab（優惠／資訊／我的卡／廣告／設定）
 *  · 管理台 `/admin/*`（只限 ai85／staff）：會員管理 ＋ 內容管理（優惠／資訊 add／edit／delete）
 */
export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/data-deletion" element={<DataDeletionPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* 公開 RSVP（邀請函專屬連結；唔需要登入） */}
        <Route path="/r/:token" element={<RsvpPage />} />

        <Route path="/member" element={<MemberLayout />}>
          <Route index element={<Navigate to="/member/benefits" replace />} />
          <Route path="benefits" element={<BenefitsPage />} />
          <Route path="news" element={<NewsPage />} />
          <Route path="cards" element={<MyCardsPage />} />
          <Route path="ads" element={<AdvertisementPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/members" replace />} />
          <Route path="members" element={<AdminMembersPage />} />
          <Route path="benefits" element={<AdminContentPage />} />
          <Route path="news" element={<AdminContentPage />} />
          <Route path="committees" element={<AdminCommitteesPage />} />
          <Route path="letters" element={<AdminLettersPage />} />
          <Route path="letters/:id" element={<AdminLetterSendPage />} />
          <Route path="sponsors" element={<AdminSponsorsPage />} />
          <Route path="sponsors/:id" element={<AdminSponsorPage />} />
          <Route path="seating" element={<AdminSeatingPage />} />
          <Route path="check-in" element={<AdminCheckInPage />} />
          <Route path="budget" element={<AdminBudgetPage />} />
          <Route path="report" element={<AdminReportPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}




